'use strict';

function ___$insertStyle(css) {
  if (!css) {
    return;
  }

  if (typeof window === 'undefined') {
    return;
  }

  var style = document.createElement('style');
  style.setAttribute('type', 'text/css');
  style.innerHTML = css;
  document.head.appendChild(style);
  return css;
}

function _interopDefault(ex) {
  return ex && typeof ex === 'object' && 'default' in ex ? ex['default'] : ex;
}

var React = require('react');

var React__default = _interopDefault(React);

require('./Thread.scss.js');

var Thread = function Thread(_a) {
  var namespaceId = _a.namespaceId,
      threadId = _a.threadId,
      backgroundColor = _a.backgroundColor;

  var _b = React.useState(500),
      height = _b[0],
      setHeight = _b[1];

  var iframe = React.useRef();

  var _c = React.useState(false),
      ready = _c[0],
      setReady = _c[1];

  React.useEffect(function () {
    var handleMessage = function handleMessage(_a) {
      var data = _a.data,
          origin = _a.origin;

      if (data.height) {
        setHeight(data.height);
      } else if (data === "ready") {
        setReady(true);
        iframe.current.contentWindow.postMessage({
          href: window.location.href
        }, "*");
      }
    };

    window.addEventListener("message", handleMessage);
    return function () {
      window.removeEventListener("message", handleMessage);
    };
  }, []);
  return React__default.createElement(React__default.Fragment, null, !ready && React__default.createElement("div", {
    className: "jthreads-container"
  }, React__default.createElement("div", {
    className: "MuiCircularProgress-root MuiCircularProgress-colorPrimary MuiCircularProgress-indeterminate",
    role: "progressbar",
    style: {
      width: "40px",
      height: "40px;"
    }
  }, React__default.createElement("svg", {
    className: "MuiCircularProgress-svg",
    viewBox: "22 22 44 44"
  }, React__default.createElement("circle", {
    className: "MuiCircularProgress-circle MuiCircularProgress-circleIndeterminate",
    cx: "44",
    cy: "44",
    r: "20.2",
    fill: "none",
    "stroke-width": "3.6"
  })))), React__default.createElement("iframe", {
    title: "JThreads",
    src: "https://jthreads-ssr.jrdn.tech/?namespaceId=" + namespaceId + "&threadId=" + threadId + "&backgroundColor=" + (backgroundColor || "FFF"),
    width: "100%",
    allowTransparency: true,
    frameBorder: "0",
    ref: iframe,
    scrolling: "no",
    style: {
      overflow: "hidden",
      height: height,
      display: ready ? "block" : "none"
    }
  }));
};

exports.default = Thread;